'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _lang = require('lodash/lang');

var _Constants = require('../actions/Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Handles changing the app's API authorization data.
 * @param {Object} state - The current authorization object.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} The new authorization object.
 */
var authorization = function authorization(state, action) {
  if ((0, _lang.isUndefined)(state)) {
    return {
      access_token: null,
      token_type: null,
      expires_in: null
    };
  }

  switch (action.type) {
    case Constants.POST_AUTH_COMPLETE:
      if (!action.error) {
        return {
          access_token: action.payload.data.access_token,
          token_type: action.payload.data.token_type,
          expires_in: action.payload.data.expires_in
        };
      }

      return state;
    default:
      return state;
  }
};

/**
 * Handles the indicators for whether certain requests are in progress.
 * @param {Object} state - A mapping between request action types and the number of
 *                         active requests of that type.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} The new mapping between request types and statuses.
 */
var requestStatus = function requestStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  // general catch-all for requests
  if (action.type.endsWith('_INIT')) {
    var requestType = action.type.slice(0, action.type.length - '_INIT'.length);

    return _extends({}, state, _defineProperty({}, requestType, state[requestType] ? state[requestType] + 1 : 1));
  } else if (action.type.endsWith('_COMPLETE')) {
    var _requestType = action.type.slice(0, action.type.length - '_COMPLETE'.length);

    return _extends({}, state, _defineProperty({}, _requestType, state[action.type] ? state[action.type] - 1 : 0));
  }

  return state;
};

exports.default = (0, _redux.combineReducers)({
  authorization: authorization,
  requestStatus: requestStatus
});


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/api.js
// module id = 1728
// module chunks = 0